// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1o8qT","colMin":"styles_colMin__3BRW1"};